import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/Dashboard/RecentDocument.css'
const RecentlyCreated = () => {
  // Static data - can be replaced with API response later
  const documents = [
    {
      id: 1,
      name: "Document name",
      type: "Skill type",
      created: "Oct 28, 2024"
    },
    {
      id: 2,
      name: "Document name",
      type: "Skill type",
      created: "Oct 28, 2024"
    },
    {
      id: 3,
      name: "Document name",
      type: "Skill type",
      created: "Oct 28, 2024"
    }
  ];

  return (
    <div className="recently-created">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title mb-4">Recently created</h5>
          
          <div className="document-list">
            {documents.map((doc) => (
              <div key={doc.id} className="document-item">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="document-info">
                    <h6 className="document-name">{doc.name}</h6>
                    <p className="document-type">{doc.type}</p>
                    <small className="document-date">created - {doc.created}</small>
                  </div>
                  <button className="btn btn-edit">Edit</button>
                </div>
              </div>
            ))}
          </div>

          <button className="btn btn-see-all w-100 mt-3">
            See all
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecentlyCreated;